<template>
  <div class="popup-overlay" @click="close">
    <div class="popup-container" @click.stop>

      <!-- HEADER -->
      <div class="popup-header">
        <h2>Notifications</h2>
        <button class="btn-close-circle" @click="close">×</button>
      </div>

      <!-- BODY -->
      <div class="popup-body">
        <div
          v-for="(noti, index) in notifications"
          :key="noti.id"
          class="notification-item"
        >

          <!-- LEFT: Project Image or Icon -->
          <img
            :src="noti.projectImg || iconFor(noti.type)"
            class="notification-image"
          />

          <!-- RIGHT Content -->
          <div class="notification-content">

            <!-- Title -->
            <p class="notification-title">
              {{ formatNotification(noti) }}
            </p>

            <!-- Time -->
            <p class="notification-time">{{ formatTime(noti.timestamp) }}</p>

            <!-- Extra payload block (optional) -->
            <div v-if="noti.payload" class="notification-extra">
              <pre>{{ JSON.stringify(noti.payload, null, 2) }}</pre>
            </div>

            <button class="mark-read-btn" @click="$emit('mark-read', noti)">
              Mark as Read
            </button>

          </div>

        </div>

        <p v-if="!notifications.length" class="notification-empty">
          You're all caught up
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import { notificationTypes } from "../../util/notificationTypes.js";

export default {
  name: "SystemNotificationPopup",

  props: {
    notifications: { type: Array, required: true }
  },

  methods: {
    close() {
      this.$emit("close");
    },

    /** Display the formatted notification title */
    formatNotification(noti) {
      const handler = notificationTypes[noti.type];
      return handler ? handler.getMessage(noti) : "New notification";
    },

    /** Format notification time */
formatTime(ts) {
  if (!ts) return "";

  // Firestore Timestamp (has .toDate())
  if (ts.toDate) ts = ts.toDate();

  const date = ts instanceof Date ? ts : new Date(ts);

  if (isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
},


    /** Get fallback icon */
    iconFor(type) {
      try {
        return require(`../../assets/${type}.png`);
      } catch (e) {
        return require("../../assets/Not Found.png");
      }
    }
  }
};
</script>

<style scoped>
/* Overlay */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
}

/* Main container */
.popup-container {
  width: 440px;
  max-height: 75vh;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
}

/* Header */
.popup-header {
  padding: 10px 16px;
  background: #ff8b32; /* orange */
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popup-header h2 {
  margin: 0;
  font-size: 16px; /* 更短更紧凑 */
  font-weight: 600;
}



/* Body */
.popup-body {
  padding: 14px;
  overflow-y: auto;
}

/* Notification Item */
.notification-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 6px;
  border-bottom: 1px solid #f0f0f0;
  gap: 12px;
}

/* Project Image / Icon */
.notification-image {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  object-fit: cover;
  background: #fff4e8;
  border: 1px solid #ffd7b4;
}

/* Right content */
.notification-content {
  flex: 1;
  min-width: 0;
}

/* Title */
.notification-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 3px;
}

/* Time */
.notification-time {
  font-size: 12px;
  color: #ff8b32; /* orange highlight */
  font-weight: 500;
}

.mark-read-btn {
  margin-top: 8px;
  background: white;
  color: #FF7222;
  border: 1px solid #FF7222;
  border-radius: 8px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mark-read-btn:hover {
  background: #FF7222;
  color: white;
}

.notification-empty {
  text-align: center;
  color: #888;
  font-size: 14px;
  padding: 24px 0;
  margin: 0;
}

/* Extra payload */
.notification-extra {
  margin-top: 8px;
  background: #fafafa;
  padding: 6px;
  border-radius: 6px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/messagebox/SystemNotificationPopup.vue